import { createFileRoute } from '@tanstack/react-router'

import { validateLeadsSearch } from '#/pages/leads'
import { LeadsProductPage } from '#/modules/pipelines/pipeline-pages'

export const Route = createFileRoute('/_shell/leads')({
  component: LeadsProductPage,
  validateSearch: validateLeadsSearch,
})
